// Lightweight route prefetch: during browser idle time, warm the webpack
// chunk cache for the routes a user is most likely to visit next. Calling the
// same dynamic import() that React.lazy uses populates the shared module cache,
// so the subsequent navigation resolves instantly (no Suspense spinner).
const importers = {
  discovery: () => import("@/pages/Discovery"),
  landing: () => import("@/pages/LandingPage"),
  attendeeAuth: () => import("@/pages/attendee/AttendeeAuth"),
  attendeeDashboard: () => import("@/pages/attendee/AttendeeDashboard"),
  eventRegister: () => import("@/pages/EventPublicRegister"),
  venueHome: () => import("@/pages/venue/VenueHome"),
  invytId: () => import("@/pages/attendee/InvytIdPage"),
  workPasses: () => import("@/pages/attendee/WorkPasses"),
  publicProfile: () => import("@/pages/attendee/PublicProfile"),
};

// Per-path plan of likely next destinations (kept small on purpose).
const PLAN = {
  "/": ["discovery", "attendeeAuth", "eventRegister"],
  "/discover": ["eventRegister", "venueHome", "publicProfile", "invytId"],
  "/my-events": ["invytId", "workPasses", "discovery"],
  "/me/id": ["workPasses", "discovery"],
  default: ["discovery"],
};

const done = new Set();
const onIdle = (cb) =>
  (typeof window !== "undefined" && window.requestIdleCallback)
    ? window.requestIdleCallback(cb, { timeout: 2000 })
    : setTimeout(cb, 400);

export function prefetchForPath(pathname) {
  const keys = PLAN[pathname] || PLAN.default;
  onIdle(() => {
    keys.forEach((k) => {
      if (done.has(k)) return;
      done.add(k);
      const imp = importers[k];
      if (imp) imp().catch(() => done.delete(k));
    });
  });
}
